import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@app/shared';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./homepage/homepage.module').then((m) => m.HomepageModule),
      },
      {
        path: 'apps/templating',
        loadChildren: () =>
          import('@mk/apps/templating').then((m) => m.TemplatingAppModule),
      },
      {
        path: 'markup-room',
        loadChildren: () =>
          import('@mk/apps/markup-room').then((m) => m.MarkupRoomModule),
      },
    ]

  },
  {
    path: '**',
    redirectTo: '404',
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [],
  exports: [RouterModule],
})
export class AppRoutingModule { }
